/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type fetchTradeOnboardingEligibilityQueryVariables = {
    readonly userId: string;
    readonly buyerId?: ReadonlyArray<string> | null;
};
export type fetchTradeOnboardingEligibilityQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly isVerifiedTrade: boolean | null;
            readonly verifiedTradeSubStatus: string | null;
        } | null;
        readonly transactions: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly checkoutDate: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type fetchTradeOnboardingEligibilityQuery = {
    readonly response: fetchTradeOnboardingEligibilityQueryResponse;
    readonly variables: fetchTradeOnboardingEligibilityQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "buyerId",
            "type": "[String!]",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isVerifiedTrade",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "verifiedTradeSubStatus",
        "args": null,
        "storageKey": null
    } as any), v4 = [
        ({
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "buyerId"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1
        } as any),
        ({
            "kind": "Literal",
            "name": "sort",
            "value": "checkoutDate desc"
        } as any)
    ], v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "checkoutDate",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "fetchTradeOnboardingEligibilityQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transactions",
                            "storageKey": null,
                            "args": (v4 /*: any*/),
                            "concreteType": "TransactionConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "fetchTradeOnboardingEligibilityQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v6 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transactions",
                            "storageKey": null,
                            "args": (v4 /*: any*/),
                            "concreteType": "TransactionConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v6 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        (v6 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "fetchTradeOnboardingEligibilityQuery",
            "id": "app-buyer-finding/231.0.0-2019-09-03T18:57:24.459Z/fetchTradeOnboardingEligibilityQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'db1dad86b64f2618e1c705f0f06895a2';
export default node;
